import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { WidgetBusinessProfile } from 'legacy/lut/components/widgets/public/businessProfile/BusinessProfile'
import { OnbPartnerFormDialog } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerFormDialog/OnbPartnerFormDialog'
import { useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { Loader } from 'core-components/library/loader'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { IFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { ICollectorData } from '../ICollectorData'

import { IAffiliatesFormProps, IPartnerInfoProps } from './models'

import styles from './LocationForm.module.scss'

export const LocationForm = (props: IAffiliatesFormProps) => {
  const crud = CrudStore.get(CrudStoreItemOnboarding.CollectedData, 'Location Form')
  const [locations, setLocations] = useState<ICollectorData>({} as ICollectorData)
  const newSource = CrudStore.get(CrudStoreItem.NewPartners, 'Location Form')
  const oldSource = CrudStore.get(CrudStoreItem.PartnerAllData, 'Location Form')
  const [partners, setPartners] = useState<IFormPartners[]>([] as IFormPartners[])
  const [showPartnerDialog, setShowPartnerDialog] = useState(false)

  const [partnerEdit, setPartnerEdit] = useState<IFormPartners | null>(null)
  const [wip, setWip] = useState(false)
  const [newPartner, setNewPartner] = useState('')
  const [addLocations, setAddLocations] = useState(false)

  const createHandler = async () => {
    // todo: add fetch form data before update/create
    try {
      if (newPartner) {
        if (locations['EntryId']) {
          const partnerInfo = JSON.parse(locations['Value']) || ([] as IPartnerInfoProps[])
          partnerInfo.push({
            BranchType: 'Entity',
            PartnerId: newPartner,
          })
          locations['Value'] = JSON.stringify(partnerInfo)
          await crud.update('677', [locations])
        } else {
          await crud.create('677', [
            {
              Value: JSON.stringify({
                BranchType: 'Location',
                PartnerId: newPartner,
              }),
              Field: 'LocationsAndAffiliates',
              Type: 'json',
              RequestId: +props.RequestId,
            },
          ])
        }
        fetchLocations()
      }
    } catch (e) {}
  }

  useEffect(() => {
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          value: props.RequestId,
          operator: Operator.EQUAL,
        },
        {
          field: 'Type',
          value: 'json',
          operator: Operator.EQUAL,
        },
        {
          field: 'Field',
          value: 'LocationsAndAffiliates',
          operator: Operator.EQUAL,
        },
      ],
    })
    fetchLocations()
  }, [])

  const fetchLocations = () => {
    crud.fetch().then((el: any) => {
      el['items'].length && parseLocations(el['items'][0]['Value'])
      setLocations(el['items'][0])
    })
  }
  const parseLocations = (locations: string) => {
    if (locations) {
      try {
        const partnerInfo = JSON.parse(locations) || ([] as IPartnerInfoProps[])
        getPartners(partnerInfo)
      } catch (e) {}
    }
  }

  const fetchPartners = async (oldLength: number, newLength: number) => {
    setWip(true)
    if (oldLength) {
      const responseOld = await oldSource.fetch()
      responseOld['items'] &&
        responseOld['items'].length &&
        responseOld['items'].forEach((item: IFormPartners) => partners.push(item))
    }
    if (newLength) {
      const responseNew = await newSource.fetch()
      responseNew['items'] &&
        responseNew['items'].length &&
        responseNew['items'].forEach((item: IFormPartners) => partners.push(item))
    }
    setPartners([...partners])
    setWip(false)
  }

  const getPartners = (partnersInfo: IPartnerInfoProps[]) => {
    const newPartnersFilters = {
      logic: Logic.AND,
      filters: [
        {
          logic: Logic.OR,
          filters: [] as IFilter[],
        },
      ],
    }
    const oldPartnersFilters = {
      logic: Logic.AND,
      filters: [
        {
          logic: Logic.OR,
          filters: [] as IFilter[],
        },
      ],
    }

    if (partnersInfo.length) {
      partnersInfo.forEach((item: IPartnerInfoProps) => {
        if (item.BranchType === 'Location') {
          const isNewPartner = !(item.PartnerId || '').indexOf('new-')
          if (isNewPartner) {
            newPartnersFilters.filters[0].filters.push({
              field: 'PartnerID',
              value: item.PartnerId,
              operator: Operator.EQUAL,
            })
          } else {
            oldPartnersFilters.filters[0].filters.push({
              field: 'PartnerID',
              value: item.PartnerId,
              operator: Operator.EQUAL,
            })
          }
        }
      })

      oldSource.setFilter(oldPartnersFilters)
      newSource.setFilter(newPartnersFilters)

      fetchPartners(oldPartnersFilters.filters.length, newPartnersFilters.filters.length)
    }
  }

  return wip ? (
    <Loader />
  ) : partners.length ? (
    <>
      <div className={styles.root}>
        {partners.map((partner, index) => (
          <div key={index}>
            <div className={styles.mainTitle}>Location {index + 1}</div>
            <div className={styles.title__root}>
              <div className={styles.title}>PPID: {partner['PartnerID']}</div>
              <Button
                onClick={() => {
                  setPartnerEdit(partner)
                  setShowPartnerDialog(true)
                }}
              >
                Edit parnter
              </Button>
            </div>
            <div className={styles.row}>
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={' Legal Name'}
                value={partner['CompanyLegalName']}
              />
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'Campaign Trading Name'}
                value={partner['CommunicationName']}
              />
            </div>
            <div className={styles.title__subheader}>Registered Address</div>
            <div className={styles.row}>
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'Address'}
                value={partner['LegalAddr1']}
              />
            </div>
            <div className={styles.row}>
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'City'}
                value={partner['LegalCity']}
              />
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'State'}
                value={partner['LegalState']}
              />
            </div>
            <div className={styles.row}>
              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'Postal Code'}
                value={partner['LegalPostalCode']}
              />

              <Input
                disabled
                classes={{
                  root: styles.inputs,
                }}
                label={'Country'}
                value={partner['LegalCountry']}
              />
            </div>
            <div className={styles.title__subheader}>Contact Details</div>
            <WidgetBusinessProfile
              metrics={props.metrics}
              crudKey={`location ${partner['PartnerID']}`}
              className={styles.contactTable}
              isOnboarding
              flexWidth={FlexDirectionBreak.p512}
              widgetParams={{}}
              pid={partner['PartnerID']}
              appSource={props.appSource}
            />
          </div>
        ))}

        <OnbPartnerFormDialog
          show={showPartnerDialog}
          onClose={() => setShowPartnerDialog(false)}
          partnerId={partnerEdit?.get('PartnerID') || ''}
          appSource={props.appSource}
        />
      </div>
      <div className={styles.createMenu}>
        <Button onClick={() => setAddLocations(!addLocations)}>
          {addLocations ? 'Hide add menu' : 'Add Location'}
        </Button>
        {addLocations && (
          <>
            <Input
              classes={{
                root: styles.inputs,
              }}
              label={'Partner Id'}
              value={newPartner}
              onChange={(item: string) => setNewPartner(item)}
            />
            <Button onClick={createHandler}>Create</Button>
          </>
        )}
      </div>
    </>
  ) : (
    <>Can't find Locations</>
  )
}
